import type { FC, ReactNode } from 'react';
import { Card } from '@interstate/components/Card';

export interface SearchResultRowProps {
    testId: string;
    isSelected: boolean;
    onSelect: () => void;
    children: ReactNode;
}

/** The row chrome every entity's results share — selection styling and click target. Content is the caller's. */
const SearchResultRow: FC<SearchResultRowProps> = ({ testId, isSelected, onSelect, children }) => (
    <Card
        data-testid={testId}
        primaryAction={onSelect}
        padding="1rem"
        sx={{
            marginBottom: '0.75rem',
            border: isSelected ? '0.125rem solid #003468' : '0.125rem solid #d1d5db',
            backgroundColor: isSelected ? '#eef2fb' : 'white',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: isSelected ? '#eef2fb' : '#f5f5f5'
            }
        }}
        content={children}
    />
);

export default SearchResultRow;
